
<template>
  <div>
    <!-- Navigation bar -->
    <nav class="navbar" :class="{ 'navbar-expanded': isSidebarHidden }">
      <div class="navbar-content">
        <!-- Toggle icon for sidebar -->
        <i
          class="fa fa-bars toggle-icon"
          @click="toggleSidebar"
          :class="{ 'icon-moved': isSidebarHidden }"
        ></i>

        <!-- Div for navbar items -->
        <div class="navbar-items-container">
          <ul class="navbar-items">
            <li class="nav-item">
            
             <router-link to="/home" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate();}"
    >
      <i class="fa fa-home"></i> Home
    </a>
  </template>
</router-link>
          </li>
          <li v-for="(product, index) in products" :key="index">
      <a :href="product.link" class="nav-link"><i class="fa fa-th"></i>{{ product.name }}</a>
    </li>
            <li class="nav-item">
              <router-link to="/sanitarware" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate();  }"
    >
      <i class="fa fa-bath"></i> Sanitaryware
    </a>
  </template>
</router-link>
          </li>
            <li class="nav-item">
              <router-link to="/faucet" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate();  }"
    >
      <i class="fa fa-tint"></i> Faucet
    </a>
  </template>
</router-link>
          </li>
          <li class="nav-item">
             <router-link to="/Granites" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate();  }"
    >
      <i class="fa fa-diamond"></i> Granites
    </a>
    </template>
</router-link>
          </li>
            <li class="nav-item">
           <router-link to="/kitchenSink" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate();  }"
    >
      <i class="fa fa-cutlery"></i> Kitchen Sink
    </a>
    </template>
</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/FlushTank" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate();  }"
    >
      <i class="fa fa-recycle"></i> Flush Tank
    </a>
    </template>
</router-link>
          </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Sidebar -->
    <div class="sidebar" :class="{ 'sidebar-hidden': isSidebarHidden }">
      <div class="sidebar-header">
        <img src="@/assets/logofinal.png" alt="Logo" class="logo" />
        <div class="brand-name">Ganesh Tiles</div>
      </div>
      <!-- Sidebar items -->
      <ul class="sidebar-items">
    <li @click="navigateTo('/admin/dashboard/Add_Tiles_Information')"><i class="fa fa-th-large"></i> Update Tiles</li>
    <li @click="navigateTo('/admin/dashboard/Add_Washbasin_Information')"><i class="fa fa-tint"></i> Update Washbasin</li>
    <li @click="navigateTo('/admin/dashboard/Add_Toilet_Seat_Information')"><i class="fa fa-circle-o"></i> Update Toilet Seat</li>
    <li @click="navigateTo('/admin/dashboard/Add_Toilet_Pan_Information')"><i class="fa fa-square-o"></i> Update Toilet Pan</li>
    <li @click="navigateTo('/admin/dashboard/Add_Toilet_Urinal_Set_Information')"><i class="fa fa-male"></i> Update Toilet Urinal Set</li>
    <li @click="navigateTo('/admin/dashboard/Add_Bathtubs_Information')"><i class="fa fa-bath"></i> Update Bathtubs</li>
    <li @click="navigateTo('/admin/dashboard/Add_RestRoom_accessories_Information')"><i class="fa fa-shower"></i> Update RestRoom accessories</li>
    <li @click="navigateTo('/admin/dashboard/Add_Granites_Information')"><i class="fa fa-diamond"></i> Update Granites</li>
    <li @click="navigateTo('/admin/dashboard/Add_Kadapa_Information')"><i class="fa fa-cube"></i> Update Kadapa</li>
    <li @click="navigateTo('/admin/dashboard/Add_Kitchen_Sink_Information')"><i class="fa fa-cutlery"></i> Update Kitchen Sink</li>
    <li @click="navigateTo('/admin/dashboard/Add_Kitchen_Sink_Accesories_Information')"><i class="fa fa-wrench"></i> Update Kitchen Sink Accesories</li>
    <li @click="navigateTo('/admin/dashboard/Add_Flush_Tank_Information')"><i class="fa fa-flask"></i> Update Flush Tank</li>
    <li @click="navigateTo('/admin/dashboard/Add_Flush_Tank_accessories_Information')"><i class="fa fa-cogs"></i> Update Flush Tank accessories</li>
      </ul>
    </div>

    <!-- Slot for main content -->
    <div :class="{ 'content-expanded': isSidebarHidden }" class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import baseURL from "@/api/config.js";
export default {
  data() {
    return {
      isSidebarHidden: false,
      categories: [],
        products: [
        { name: "Tiles",  link: "/wall-tiles" },
       ] 
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarHidden = !this.isSidebarHidden;
    },
    navigateTo(path) {
      this.$router.push({ path });
    },
    async fetchData() {
    const response = await fetch(`${baseURL}/TilesFrontEndController/getcategories`);
        const data = await response.json();
        console.log(data.categories);
        this.categories = data.categories;
        this.products[0].link = `/tiles/category/${this.categories[0].category_id}/${encodeURIComponent(
      this.categories[0].category_name
    )}`;
    
    }
    
  },
  mounted() {
  
 this.fetchData();
    
  },
  

};
</script>

<style scoped>
@import './Global.css';
.navbar {
  width: 100%;
  background-color: #2F4F4F;
  color: white;
  display: flex;
  align-items: center;
  padding: 0 20px;
  position: relative;
  transition: padding-left 0.3s ease;
  height: 60px;
}

.navbar-content {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  height: 100%;
}

.toggle-icon {
  cursor: pointer;
  font-size: 24px;
  color: white;
  padding: 5px;
  border-radius: 5px;
  transition: left 0.3s ease;
  position: absolute;
  left: 253px;
}

.icon-moved {
  left: 10px;
}

.navbar-items-container {
  display: flex;
  justify-content: center;
  flex-grow: 1;
}

.navbar-items {
  list-style-type: none;
  display: flex;
  gap: 20px;
  margin: 0;
  padding: 0;
}

.navbar-items li {
  cursor: pointer;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
}

.navbar-items li i {
  margin-right: 8px;
}

.navbar-items li:hover {
  color: #007bff;
}

.sidebar {
  width: 250px;
  height: 100vh;
  background-color: #2c3e50;
  color: white;
  transition: transform 0.3s ease, width 0.3s ease;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.sidebar-hidden {
  transform: translateX(-250px);
}

.sidebar-header {
  display: flex;
  align-items: center;
  padding: 20px;
  height: 60px;
}

.logo {
  width: 50px;
  height: 50px;
  object-fit: contain;
  margin-right: 10px;
}

.brand-name {
  font-size: 25px;
  font-weight: bold;
  color: white;
  font-family: 'Roboto Slab', serif;
}

.sidebar-items {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.sidebar-items li {
  padding: 8px 20px;
  text-align: left;
  display: flex;
  align-items: right;
  transition: background-color 0.3s ease;
  border-left: 3px solid transparent;
}

.sidebar-items li i {
  margin-right: 12px;
}

.sidebar-items li:hover {
  background-color: #34495e;
  cursor: pointer;
  border-left: 3px solid #007bff;
}

.content {
  margin-left: 250px;
  transition: margin-left 0.3s ease;
  padding: 20px;
}

.content-expanded {
  margin-left: 0;
}

.sidebar-hidden ~ .content {
  margin-left: 0;
}

.header-title {
  font-size: 24px;
  color: var(--primary-color);
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .sidebar {
    width: 200px;
  }

  .sidebar-hidden {
    transform: translateX(-200px);
  }

  .content {
    margin-left: 200px;
  }

  .content-expanded {
    margin-left: 0;
  }

  .toggle-icon {
    left: 200px;
  }

  .icon-moved {
    left: 10px;
  }

  .navbar-items-container {
    display: none;
  }
}

@media (max-width: 480px) {
  .sidebar {
    width: 150px;
  }

  .sidebar-hidden {
    transform: translateX(-150px);
  }

  .content {
    margin-left: 150px;
  }

  .content-expanded {
    margin-left: 0;
  }

  .toggle-icon {
    left: 150px;
  }

  .icon-moved {
    left: 10px;
  }

  .navbar-items-container {
    display: none;
  }
}
</style>
